import { generateDistinctColors } from "utils/generateDistinctColors";
import type { PlanRouteGroupV3 } from "../types";
import type { BulkAddPlanRoutes } from "./types";

export const bulkAddPlanRoutes: BulkAddPlanRoutes = ({ plan, routes }) => {
  const existingGroupByLabel = new Map<string, PlanRouteGroupV3>(
    plan.routeGroups.map((group) => [group.label, group]),
  );

  const newGroupLabels: string[] = [];
  const newGroupRouteTypeIdByLabel = new Map<string, number>();
  for (const { groupLabel, routeTypeId } of routes) {
    if (existingGroupByLabel.has(groupLabel)) continue;
    if (newGroupRouteTypeIdByLabel.has(groupLabel)) continue;
    newGroupLabels.push(groupLabel);
    newGroupRouteTypeIdByLabel.set(groupLabel, routeTypeId);
  }

  const totalGroupCount = plan.routeGroups.length + newGroupLabels.length;
  const palette = generateDistinctColors({ count: totalGroupCount });
  const newGroupColorByLabel = new Map<string, [number, number, number]>(
    newGroupLabels.map((label, index) => [
      label,
      palette[plan.routeGroups.length + index],
    ]),
  );

  const updatedGroupByLabel = new Map<string, PlanRouteGroupV3>();
  for (const group of plan.routeGroups) {
    updatedGroupByLabel.set(group.label, group);
  }
  for (const label of newGroupLabels) {
    updatedGroupByLabel.set(label, {
      route_type_id: newGroupRouteTypeIdByLabel.get(label)!,
      label,
      meters: 0,
      routes: [],
      rgb: newGroupColorByLabel.get(label)!,
      // Matches backend: new route types created via bulk-create are CONFIDENT
      cableTypeStatus: "confident",
    });
  }

  for (const { scaledRoute, groupLabel } of routes) {
    const group = updatedGroupByLabel.get(groupLabel)!;
    updatedGroupByLabel.set(groupLabel, {
      ...group,
      routes: [...group.routes, scaledRoute],
      meters: group.meters + (Number(scaledRoute.meters) || 0),
    });
  }

  const orderedLabels = [
    ...plan.routeGroups.map((group) => group.label),
    ...newGroupLabels,
  ];

  const updatedRouteGroups = orderedLabels.map(
    (label) => updatedGroupByLabel.get(label)!,
  );

  return {
    ...plan,
    routeGroups: updatedRouteGroups,
  };
};
